import { pageNavItems, PageNavItem } from '@components-clean/page-nav/page-nav-menu-items.data';
import { ActiveItemPerLevelInfo } from '@components-clean/page-nav/types';
import { AdminPaths, LoginPaths, PrivatePaths, PublicPaths } from '@config/routes/paths';

type PageNavItemWithItems = PageNavItem & { items?: PageNavItemWithItems[] };

function findPageNavItemByKey(
    items: PageNavItemWithItems[],
    key: string | undefined,
    path: PageNavItemWithItems[] = [],
): PageNavItemWithItems[] | null {
    if (!key) return null;

    let result: PageNavItemWithItems[] | null = null;

    items.some((item) => {
        if (item.key === key) {
            result = [...path, item];
            return true;
        }
        if (item.items) {
            const found = findPageNavItemByKey(item.items, key, [...path, item]);
            if (found) {
                result = found;
                return true;
            }
        }
        return false;
    });

    return result;
}

export const parsePathnameToActiveMenuInfo = (path: string): ActiveItemPerLevelInfo => {
    const levels = path?.split('/').filter(Boolean);

    if (!levels) return {};

    const pathTopLevel = levels.at(0);
    const pathSecondLevel = levels.at(1);
    const pathThirdLevel = levels.at(2);

    const joinedPath = [
        pathTopLevel,
        pathSecondLevel,
        pathSecondLevel !== 'data-view' && pathSecondLevel !== 'risk-log' ? pathThirdLevel : undefined,
    ]
        .filter(Boolean)
        .join('/');
    const combinedPaths = [...AdminPaths, ...PrivatePaths, ...LoginPaths, ...PublicPaths];
    const pathRoute = combinedPaths.find((route) => route.path?.includes(`/${joinedPath}`));
    const routeKey = pathRoute?.key;

    const pageNavItemsArray = pageNavItems();

    const pageNavItem = findPageNavItemByKey(pageNavItemsArray, routeKey);

    return pageNavItem
        ? {
              topLevel: { id: pageNavItem[0]?.key ?? '', params: {} },
              secondLevel: { id: pageNavItem[1]?.key ?? '', params: {} },
              thirdLevel:
                  routeKey === 'cm2-data-views'
                      ? {
                            id: pageNavItem[1]?.key ?? '',
                            params: { dataView: pathThirdLevel ?? '' },
                        }
                      : { id: pageNavItem[2]?.key ?? '', params: {} },
          }
        : {};
};
